import { Component, OnInit, ViewContainerRef, ComponentFactoryResolver, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import * as fromModel from '../services/models';
import { Constant } from '../../environments/constants';
import { ClientListComponent } from '../plan/client-list/client-list.component';
import { CashFlowComponent } from '../plan/cash-flow/cash-flow.component';
import { CashFlowTableComponent } from '../plan/cash-flow-table/cash-flow-table.component';
import { NetCashFlowByYearComponent } from '../plan/net-cash-flow-by-year/net-cash-flow-by-year.component';
import { AssetProjectionComponent } from '../plan/asset-projection/asset-projection.component';
import { GoalDetailsComponent } from '../plan/goal-details/goal-details.component';
import { GoalsComponent } from '../plan/goals/goals.component';
import { ExpenseListComponent } from '../plan/expense-list/expense-list.component';
import { AccountListComponent } from '../plan/account-list/account-list.component';
import { LliabilityListComponent } from '../plan/liability-list/liability-list.component';
import { IncomeListComponent } from '../plan/income-list/income-list.component';
import { MilestoneComponent } from '../plan/milestone/milestone.component';
import { IncomeComponent } from '../plan/income/income.component';
import { FamilyViewComponent } from '../plan/family-view/family-view.component';
import { TaxPortfolioComponent } from '../plan/tax-portfolio/tax-portfolio.component';

@Component({
  selector: 'gp-component-container',
  templateUrl: './component-container.component.html',
  styleUrls: ['./component-container.component.scss']
})
export class ComponentContainerComponent implements OnInit, OnChanges{

  @Input('ComponentType') componentType: fromModel.COMPONENTTYPES;
  // @Input('SaveId') saveId: string;
  // @Output() onSave: EventEmitter<any> = new EventEmitter();
  
  
  constructor(
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver
    ) {       
    }

  ngOnInit(): void {

    console.log("%c Enter: Component Container - ngOnInit for Component Type - " + this.componentType.toUpperCase(), Constant.consoleLogStyle.frameworkComponentContainer);
    //this.loadComponent();
    //this.viewContainerRef.clear();    
    
    console.log("%c Exit: Component Container - ngOnInit for Component Type - " + this.componentType.toUpperCase(), Constant.consoleLogStyle.frameworkComponentContainer);
  }

  ngOnChanges(changes: SimpleChanges) {    
    this.loadComponent();
  }

  loadComponent(){
    this.viewContainerRef.clear();    
    switch (this.componentType.toUpperCase()) {
      case fromModel.COMPONENTTYPES.CLIENTREL.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ClientListComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);  
        //componentRef.instance.componentTemplate = <fromModel.IProfile>this.componentTemplate;    
        break;
      }
      case fromModel.COMPONENTTYPES.CASHFLOWS.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CashFlowComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      case fromModel.COMPONENTTYPES.CASHFLOWSTABLE.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CashFlowTableComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      case fromModel.COMPONENTTYPES.NETCASHFLOWSBYYEAR.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(NetCashFlowByYearComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      case fromModel.COMPONENTTYPES.ASSETPROJ.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(AssetProjectionComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      case fromModel.COMPONENTTYPES.GOALS.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(GoalsComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      case fromModel.COMPONENTTYPES.GOALDETAILS.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(GoalDetailsComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      case fromModel.COMPONENTTYPES.EXPLIST.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(ExpenseListComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      case fromModel.COMPONENTTYPES.ACCLIST.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(AccountListComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        // componentRef.instance.saveId = this.saveId;    
        // componentRef.instance.onSave.subscribe(data=>{
        //   this.onSave.emit();
        // });            
        break;
      }
      case fromModel.COMPONENTTYPES.LBACCLIST.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(LliabilityListComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);      
        //componentRef.instance.listType = "LB";    
        // componentRef.instance.saveId = this.saveId;    
        // componentRef.instance.onSave.subscribe(data=>{
        //   this.onSave.emit();
        // });            
        break;
      }
      case fromModel.COMPONENTTYPES.INCLIST.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(IncomeListComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      case fromModel.COMPONENTTYPES.MILESTONE.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MilestoneComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      case fromModel.COMPONENTTYPES.INCOME.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(IncomeComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }

      case fromModel.COMPONENTTYPES.FAMILYVIEW.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(FamilyViewComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }

      case fromModel.COMPONENTTYPES.TAXPORT.toUpperCase(): {
        const componentFactory = this.componentFactoryResolver.resolveComponentFactory(TaxPortfolioComponent);
        const componentRef = this.viewContainerRef.createComponent(componentFactory);          
        break;
      }
      

      
      


      default: break;
    }    
  }




  
}
